/**
 * Application Configuration
 * Centralized configuration values
 */

export const CONFIG = {
  // File Upload
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  SUGGESTED_MAX_VEHICLES: 300, // Suggested limit (not enforced)
  ALLOWED_FILE_TYPES: ['.xlsx'],
  
  // Processing
  DEFAULT_DELAY_MS: 3000, // Default delay between API calls in milliseconds (3 seconds)
  MIN_DELAY_MS: 0, // Minimum allowed delay
  MAX_DELAY_MS: 5000, // Maximum allowed delay (5 seconds)

  // API
  API_TIMEOUT: 30000, // 30 seconds

  // UI
  ANIMATION_DURATION: 300, // milliseconds
  SHIMMER_DURATION: 1500, // milliseconds
  TOAST_DURATION: 3000, // milliseconds

  // Table
  ROWS_PER_PAGE: 50,
  MAX_MESSAGE_LENGTH: 50,
} as const;
